import { Row } from 'spw-shared/globalComponents';
import React from 'react';
import {
  ColorSwatch,
  HexValue,
  SmallColorBubble,
} from 'spw-projects/colors/styles';
import styled from 'styled-components';
import { Box } from '@mui/material';

type Props = {
  gradientColors: string[];
  gradientColorIndex: number;
  onSelectColor: (gradientColorIndex: number) => void;
};

const GradientRow = styled(Row)`
  margin: 6px 0 6px 0;
`;

const ColorGradient = ({
  gradientColors,
  gradientColorIndex,
  onSelectColor,
}: Props) => {
  return (
    <Box>
      <GradientRow data-cy="gradient-colors">
        {gradientColors.map((gradientColor, colorIndex) => {
          const uuid = new Date().getTime() + colorIndex;
          return (
            <ColorSwatch
              className={colorIndex === gradientColorIndex ? 'selected' : ''}
              key={`${uuid}`}
              onClick={() => onSelectColor(colorIndex)}
              color={gradientColor}
            />
          );
        })}
      </GradientRow>
      <Row>
        <SmallColorBubble color={gradientColors[gradientColorIndex]} />
        <HexValue>
          Hex: {gradientColors[gradientColorIndex]?.replace('#', '')}
        </HexValue>
      </Row>
    </Box>
  );
};

export default ColorGradient;
